<template>
  <div
    class="BaseNode"
    :class="{
      BaseNode__hasError: hasError
    }"
    :style="{
      '--node-color': color
    }"
  >
    <div class="BaseNode_container">
      <div class="BaseNode_header">
        <div class="BaseNode_title">{{fullTitle}}</div>
        <Icon
          v-if="icon"
          :icon="icon"
        />
      </div>
      <div
        v-if="$slots.default"
        class="BaseNode_content"
      >
        <slot />
      </div>
      <div class="BaseNode_name">{{node.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$t'],
  props: {
    node: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    color: {
      type: String,
      default: '#666'
    },
    icon: {
      type: String
    },
    editorErrors: {
      type: Array,
      required: true
    },
    position: {
      type: Number
    }
  },
  computed: {
    hasError() {
      const id = this.node.id
      return !!this.editorErrors.find(d => d.nodeId === id)
    },
    fullTitle() {
      const {title, node, position} = this
      let text = this.$t(`node.${node.componentType}.name`)
      if (title) {
        text += ': ' + title
      }
      if (position) {
        text += ' ' + position
      }
      // text += ` [${node.id}]`
      return text
    }
  }
}
</script>

<style lang="scss">
$errorColor: #bf0610;
$shadow: 0 2px 5px rgba(0, 0, 0, 0.3);

.BaseNode_container {
  position: relative;
  background: #fff;
  border: 2px solid var(--node-color, #666);
  border-radius: 3px;
  box-shadow: $shadow;

  &:hover {
    filter: brightness(120%);
    cursor: pointer;
  }
}

.BaseNode_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 8px;
  background: var(--node-color, #666);
  color: #fff;
  font-size: 13px;
}

.BaseNode_content {
  padding: 8px;
}

.BaseNode__hasError {
  .BaseNode_container {
    outline: 4px dashed $errorColor;
    outline-offset: 8px;
  }
  .BaseNode_name {
    margin-top: 18px;
  }
}

.BaseNode_name {
  position: absolute;
  width: 100%;
  margin-top: 5px;
  color: #666;
  font-size: 11px;
  text-align: center;
  text-shadow:
    1px 0px 0px #fff,
    -1px 0px 0px #fff,
    0px 1px 0px #fff,
    0px -1px 0px #fff;
  white-space: nowrap;
  pointer-events: none;
}
</style>
